export const checkbox0 = "M13.4444 1H2.55556C1.7 1 1 1.7 1 2.55556V13.4444C1 14.3 1.7 15 2.55556 15H13.4444C14.3 15 15 14.3 15 13.4444V2.55556C15 1.7 14.3 1 13.4444 1Z"

export const checkbox1 = "M12 9H4V7H12V9Z"

export const checkbox2 = "M6.57143 12L3 8.16123L4.00714 7.07869L6.57143 9.82726L11.9929 4L13 5.09021L6.57143 12Z"

export const downChevron = "M11.825 5L8 8.81667L4.175 5L3 6.175L8 11.175L13 6.175L11.825 5Z"

export const leftChevron = "M11.175 4.175L10 3L5 8L10 13L11.175 11.825L7.35833 8L11.175 4.175Z"

export const radio0 = "M8 1C4.136 1 1 4.136 1 8C1 11.864 4.136 15 8 15C11.864 15 15 11.864 15 8C15 4.136 11.864 1 8 1Z"

export const radio1 = "M8 5C6.344 5 5 6.344 5 8C5 9.656 6.344 11 8 11C9.656 11 11 9.656 11 8C11 6.344 9.656 5 8 5Z"

export const rightChevron = "M6.175 3L5 4.175L8.81667 8L5 11.825L6.175 13L11.175 8L6.175 3Z"

export const upChevron = "M8 5L3 10L4.175 11.175L8 7.35833L11.825 11.175L13 10L8 5Z"